import { computed, ComputedRef } from 'vue';
import { textUtil } from '../../../shared/utils/textUtil';

export const MAX_CHARS_BEFORE_SEARCH_HIT = 50;

export function normalizePlainFromHtml(html: string): string {
  const plain = textUtil.stripHtmlFromText(html);
  return plain.replace(/\s+/g, ' ').trim();
}

export function findFirstSearchHitIndex(plain: string, searchString: string): number {
  const query = searchString.trim();
  if (!query || !plain) {
    return -1;
  }
  return plain.toLowerCase().indexOf(query.toLowerCase());
}

export function buildPlainExcerptAroundHit(plain: string, searchString: string): string {
  if (!plain) {
    return '';
  }
  const hitIndex = findFirstSearchHitIndex(plain, searchString);
  if (hitIndex === -1) {
    return plain;
  }
  const beforeStart = Math.max(0, hitIndex - MAX_CHARS_BEFORE_SEARCH_HIT);
  const before = plain.slice(beforeStart, hitIndex);
  const fromHit = plain.slice(hitIndex);
  const leadingEllipsis = beforeStart > 0 ? '...' : '';
  return `${leadingEllipsis}${before}${fromHit}`;
}

export function useSearchPostContentPlainExcerpt(
  getHtml: () => string | null | undefined,
  getSearchString: () => string
): { contentPlainExcerpt: ComputedRef<string> } {
  const contentPlainExcerpt = computed(() =>
    buildPlainExcerptAroundHit(normalizePlainFromHtml(getHtml() ?? ''), getSearchString())
  );
  return { contentPlainExcerpt };
}
